module.exports = __webpack_public_path__ + "img/ubication.ecc4671b.jpg";